var _circle, _rect, _path, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#222228"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 60.9998,
    width: 11,
    height: 28,
    rx: 5.5,
    fill: "#4A67FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 69.4672C43 66.9233 44.6043 64.6558 47.0032 63.8092L50.9546 62.4147C51.3174 62.2867 51.6916 62.1938 52.0721 62.1375L62.3632 60.6129C64.5426 60.29 66.5 61.9787 66.5 64.182C66.5 65.3873 65.8981 66.5131 64.8957 67.1825L60.9333 69.8286C60.0833 70.3962 59.7084 71.4555 60.012 72.4314C60.3041 73.3702 61.1592 74.0206 62.142 74.0513L73.7256 74.4133C75.4856 74.4683 77.1809 73.7474 78.3623 72.4417L83.8971 66.3243C85.093 65.0024 87.0933 64.7951 88.5349 65.8436C90.148 67.0167 90.4506 69.3013 89.1985 70.8539L80.0558 82.1908C79.3652 83.0471 78.4526 83.6971 77.4175 84.0697L67.4852 87.6451C66.8333 87.8798 66.1457 87.9998 65.4529 87.9998H49C45.6863 87.9998 43 85.3135 43 81.9998V69.4672Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 45,
    r: 14,
    fill: "#4A67FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0215 51.0195H69.7275L70.8066 45.8564H72.168L73.2471 51.0195H75.9531L77.1235 45.8564H78.9912V44.1631H77.5054L78.6758 39H76.1191L75.1562 44.1631H73.77L72.6494 39H70.3418L69.2212 44.1631H67.8433L66.8721 39H64.3154L65.4775 44.1631H64V45.8564H65.8594L67.0215 51.0195ZM68.1587 45.8564H68.8477L68.5322 47.3174H68.4326L68.1587 45.8564ZM71.1553 44.1631L71.4375 42.8184H71.5371L71.8193 44.1631H71.1553ZM74.1353 45.8564H74.8325L74.5586 47.334H74.459L74.1353 45.8564Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon1);
export default __webpack_public_path__ + "static/media/money-icon-1.af9de8f6fca20fe8d925a634c848c96c.svg";
export { ForwardRef as ReactComponent };